import { render, staticRenderFns } from "./social_select_button.vue?vue&type=template&id=3c49d964&"
import script from "./social_select_button.vue?vue&type=script&lang=js&"
export * from "./social_select_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports